module.exports = __webpack_public_path__ + "img/2.7ee135f2.jpg";